import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { Button, Space, Typography } from 'antd';
import ContentHeader from '~/components/ContentHeader';
import { useGetApplication, useSubmitStep } from '~/controllers/wizard';
import ReviewAndSubmitTabs from './components/ReviewAndSubmitTabs';
import BusinessDetails from '~/pages/ksa/application/reviewAndSubmit/Elements/BusinessDetails';
import Actions from '~/components/Actions';
import Form from '~/components/Form';
import { Stage } from '~/types/Application';
import { useHistory, useLocation } from 'react-router';
import ReviewAndSubmitRightContent from '~/components/views/ReviewAndSubmit/ReviewAndSubmitRightContent';
import BusinessOwners from '~/pages/ksa/application/reviewAndSubmit/Elements/BusinessOwners';
import ProductsSummary from '~/pages/ksa/application/reviewAndSubmit/Elements/ProductsSummary';
import BankDetails from '~/pages/ksa/application/reviewAndSubmit/Elements/BankDetails';
import Disclousure from '~/pages/ksa/application/reviewAndSubmit/Elements/Disclousure';
import paths from '~/pages/paths';
import { useIsMobile } from '~/hooks/useScreenSizes';
import { getTrackingId } from '~/utils/handleGetUtm';

const ReviewAndSubmit: FC = () => {
  const { t } = useTranslation('ksaApplication');
  const applicationQuery = useGetApplication();
  const location = useLocation();
  const terminationInfo = applicationQuery?.data?.terminationReason;
  const history = useHistory();
  const isMobile = useIsMobile();
  const [form] = Form.useForm();
  const submitMutation = useSubmitStep();
  const onSubmit = () => {
    (window as any).dataLayer.push({
      event: 'event_formsubmit',
      page_ln: 'en',
      page_name: window.location.href,
      page_source: document.referrer || 'direct',
      page_section: 'Review',
      trackingId: getTrackingId(applicationQuery?.data),
      user_id: localStorage.getItem('sob_temp_uid'),
    });
    return submitMutation.mutateAsync({});
  };
  return (
    <Container className="ReviewAndSubmit">
      <FullWidthSpace direction="vertical" size={isMobile ? 20 : 32}>
        <ContentHeader
          title={t('Review & Confirm')}
          subtitle={t('Check and confirm your data.')}
          stageNumber={3}
        />
        <BusinessDetails data={applicationQuery?.data?.payload?.companyInformation} payload={applicationQuery?.data?.payload} />
        <BusinessOwners data={applicationQuery?.data?.payload} />
        <ProductsSummary payload={applicationQuery?.data?.payload} />
        <BankDetails data={applicationQuery?.data?.payload} />
        <Disclousure data={applicationQuery?.data?.payload} />
      </FullWidthSpace>

      <ReviewForm
        payloadKey="reviewAndSubmit"
        form={form}
        stage={Stage.ksaApplication}
      >
        <Form.Item name="reviewAndSubmit" initialValue="reviewAndSubmit" hidden />
        <Actions
          id="reviewAndSubmit_continueButton"
          onClick={onSubmit}
          formName={location.pathname}
        />
        {isMobile && (
          <ContactUsButton
            type="text"
            onClick={() => {
              history.push(paths.ksa.contactUs);
            }}
          >
            {t('Contact Us')}
          </ContactUsButton>
        )}
      </ReviewForm>
    </Container>
  );
};

const Container = styled.div`
  .ReviewAndSubmitTabs {
    margin-top: 40px;
  }
  
`;

const FullWidthSpace = styled(Space)`
  width: 100%;
`;

const ReviewForm = styled(Form)`
  margin-top: 46px;
`;

const ContactUsButton = styled(Button)`
  width: 100%;
  margin-top: 20px;
  font-weight: 600;
  color: #0069b1;
`;

export default ReviewAndSubmit;
